import { Dropdown } from 'view-design';

//从环境变量获取auth服务的路径
const VUE_APP_ROLE_PATH = process.env.VUE_APP_BASE_API;
// const baseURL = VUE_APP_ROLE_PATH;
const baseURL = VUE_APP_ROLE_PATH;

export default {
  // 工厂管理
  factoryManegement: {
    factoryList: `${baseURL}/biz/enterprise/factory/list`,
    addFactory: `${baseURL}/biz/enterprise/factory`,
    queryFactoryDetail: `${baseURL}/biz/enterprise/factory/`,
    editFactory: `${baseURL}/biz/enterprise/factory`,
    delFactory: `${baseURL}/biz/enterprise/factory`
  },
  // 车间管理
  workshopManagement: {
    factoryList: `${baseURL}/biz/enterprise/factory/list`,
    addFactory: `${baseURL}/biz/enterprise/factory`,
    queryFactoryDetail: `${baseURL}/biz/enterprise/factory/`,
    editFactory: `${baseURL}/biz/enterprise/factory`,
    delFactory: `${baseURL}/biz/enterprise/factory`
  },
  // 点位标识管理
  pointManagement: {
    getWorkShopLayout: '/biz/workshop/sceneLayout',
    workshopScene: '/biz/enterprise/scenePoint/saveWorkshopScenePoint',
    getScenePointList: '/biz/enterprise/scenePoint/list',
    getSceneEquipInfoBySceneId: '/biz/enterprise/scenePoint/getSceneEquipInfoBySceneId',
    savePointDevice: '/biz/enterprise/scenePoint/savePointDevice',
    getBizDeviceName: '/system/dict/data/type/biz_device_name',
    delScenePoint: '/biz/enterprise/scenePoint',
    // 设备解绑
    unBindDevice: '/biz/enterprise/scenePoint/unbind',
    // 查询场景下的设备
    queryDeviceOfScene: '/biz/enterprise/scenePoint/getScenePointEquipInfoBySceneId'
  },
  // 下拉接口管理
  dropdownList: {
    customerList: `${baseURL}/biz/downList/customer`,
    factoryList: `/biz/downList/factory`,
    workshopList: `/biz/downList/workshop`,
    sceneList: `${baseURL}/biz/downList/scene`
  },
  // 监控看板
  monitorDashbord: {
    getWorkShopLayout: '/biz/enterprise/monitor/getWorkshopLayoutId/',
    getMonitVideoUrl: '/biz/play/live',
    stopPlay: '/biz/stop/live',
    stopHistoryPlay: '/biz/stop/history',
    getHistoryPlay: '/biz/play/history'
  },
  // 报警设置
  alarmManagement: {
    // 视频AI事件报警内容
    getAiEventList: '/biz/alarmAiEdgeMachineContent/list',
    addAiEventAlarm: '/biz/alarmAiEdgeMachineContent',
    editAiEventAlarm: '/biz/alarmAiEdgeMachineContent',
    delAiEventAlarm: '/biz/alarmAiEdgeMachineContent',
    getAiEventAlarmDetail: '/biz/alarmAiEdgeMachineContent',
    exportAiEventAlarmDetail: '/biz/alarmAiEdgeMachineContent/export',
    // 视频AI事件报警设置
    alarmAiEdgeMachineSettingList: '/biz/alarmAiEdgeMachineSetting/list', // 列表
    alarmAiEdgeMachineSetting: '/biz/alarmAiEdgeMachineSetting', // 新增
    alarmAiEdgeMachineSettingExport: '/biz/alarmAiEdgeMachineSetting/export', //导出
    getAlarmAiEdgeMachineSetting: '/biz/alarmAiEdgeMachineSetting', // 获取详情
    delAlarmAiEdgeMachineSetting: '/biz/alarmAiEdgeMachineSetting', // 删除
    editAlarmAiEdgeMachineSetting: '/biz/alarmAiEdgeMachineSetting', // 编辑
    // 压差报警设置
    getAlarmPressureTxSettingList: '/biz/alarmPressureTxSetting/list',
    alarmPressureTxSetting: '/biz/alarmPressureTxSetting',
    exportAlarmPressureTxSetting: '/biz/alarmPressureTxSetting/export',
    // 空气洁净度报警设置
    getAlarmAirParticleCounterSettingList: '/biz/alarmAirParticleCounterSetting/list',
    alarmAirParticleCounterSetting: '/biz/alarmAirParticleCounterSetting',
    exportAlarmPressureTxSetting: '/biz/alarmAirParticleCounterSetting/export',
    // 新增温湿度报警设置
    getAlarmTemperatureHumiditySensorList: '/biz/alarmTemperatureHumiditySensor/list',
    alarmTemperatureHumiditySensor: '/biz/alarmTemperatureHumiditySensor',
    exportAlarmAirParticleCounterSetting: '/biz/alarmTemperatureHumiditySensor/export',
    // 新增臭氧报警设置
    getAlarmOzoneDetectorSettingList: '/biz/alarmOzoneDetectorSetting/list',
    alarmOzoneDetectorSetting: '/biz/alarmOzoneDetectorSetting',
    exportAlarmOzoneDetectorSetting: '/biz/alarmOzoneDetectorSetting',
    getUserAuthList: '/biz/baseData/authUserList',
    getUseDropDownList: `/biz/downList/authUser`
  },
  // 报警明细
  alarmDetail: {
    getAiEdgeMachineList: '/biz/alarmDetail/aiEdgeMachine/list',
    getPressureDifList: '/biz/alarmDetail/pressureTx/list',
    getAirCleanList: '/biz/alarmDetail/airParticleCounter/list',
    getTemHumidityList: '/biz/alarmDetail/temperatureHumidity/list',
    getOzoneDetectorList: '/biz/alarmDetail/ozoneDetector/list',
    handleAlarm: '/biz/alarmDetail/handle'
  },
  // 视频Ai事件查询
  cAiEventData: {
    getCameraEventList: '/biz/event/camera/list',
    exportCAiEvent: '/biz/event/camera/export',
    delVideoAiEvent: '/biz/event/camera',
    getEventCameraDetail: '/biz/event/camera',
    uploadBase64: '/biz/event/camera/uploadImages',
    getUserList: '/system/user/list',
    getImgsUrl: '/resource/oss/listByIds'
  },
  // 稽核事件
  videoCheck: {
    getCheckList: '/biz/eventCameraAudit/list',
    upCameraImages: '/biz/eventCameraAudit/uploadImages',
    delCheckVideo: '/biz/eventCameraAudit',
    eventCameraAudit: '/biz/eventCameraAudit',
    getEventTypeList: '/system/dict/data/type/camera_event_type'
  }
};
